import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\Klienti - D\\WHO bg\\www - AI\\src\\app\\home-page\\components\\CertificationsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\Klienti - D\\WHO bg\\www - AI\\src\\app\\home-page\\components\\ChatbotWidget.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\Klienti - D\\WHO bg\\www - AI\\src\\app\\home-page\\components\\GlobalPresenceSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\Klienti - D\\WHO bg\\www - AI\\src\\app\\home-page\\components\\HeroSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\Klienti - D\\WHO bg\\www - AI\\src\\app\\home-page\\components\\HowItWorksSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\Klienti - D\\WHO bg\\www - AI\\src\\app\\home-page\\components\\MyWTOPortalSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\Klienti - D\\WHO bg\\www - AI\\src\\app\\home-page\\components\\NewsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\Klienti - D\\WHO bg\\www - AI\\src\\app\\home-page\\components\\ServicesSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\Klienti - D\\WHO bg\\www - AI\\src\\components\\Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\Klienti - D\\WHO bg\\www - AI\\src\\components\\Header.tsx");
